import { clsx } from "@alpacahq/ui/old";

const OPTIONS: {
  label: string;
  value: boolean;
}[] = [
  {
    label: "24 hour market",
    value: true,
  },
  {
    label: "Regular hours",
    value: false,
  },
];

interface ExtendedHoursButtonsProps {
  isExtendedHours: boolean;
  onChange: (isExtendedHours: boolean) => void;
}

export const ExtendedHoursButtons = ({
  isExtendedHours,
  onChange,
}: ExtendedHoursButtonsProps) => (
  <div className="flex flex-col gap-1">
    <label className="font-semibold text-gray-700 text-sm">
      Trading session
    </label>
    <div className="inline-flex overflow-hidden rounded-lg border border-gray-200 bg-white">
      {OPTIONS.map((option) => {
        const isSelected = isExtendedHours === option.value;
        return (
          <button
            key={option.value.toString()}
            type="button"
            onClick={() => onChange(option.value)}
            className={clsx(
              "flex-1 px-4 py-2 font-medium text-sm transition-colors",
              "first:rounded-l-md",
              "last:rounded-r-md",
              isSelected
                ? "border border-blue-600 bg-blue-50 text-blue-600"
                : "border border-gray-200 bg-white text-gray-600 hover:text-gray-800 [&:not(:first-child)]:border-l-0",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  </div>
);
